import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button } from "@gravity-ui/uikit";
import block from "bem-cn-lite";
import { ArrowDown, ArrowUp } from "@gravity-ui/icons";
import { useLocation } from "react-router-dom";
import "./ScrollButton.scss";
const b = block("scroll-button");
//сколько прокрутить экранов чтобы появилась кнопка
const multiplierScroll = 2;
export const ScrollButton = ({ targetRef, twinDirection, outScroll, containerRef, scrollThreshold = 1600, }) => {
    const { scrollHeight, clientHeight } = document.documentElement;
    const [hiddenScroll, setHiddenScroll] = useState(true);
    const [direction, setDirection] = useState("up");
    const [scrollContainer, setScrollContainer] = useState(null);
    const location = useLocation();
    // Функция поиска скролл-контейнера
    const findScrollContainer = (startElement) => {
        let element = startElement || containerRef?.current || document.body;
        while (element && element !== document.body) {
            const { overflow, overflowY } = window.getComputedStyle(element);
            // Проверяем, есть ли у элемента скролл
            if ((overflow === "auto" ||
                overflow === "scroll" ||
                overflowY === "auto" ||
                overflowY === "scroll") &&
                element.scrollHeight > element.clientHeight) {
                return element;
            }
            element = element.parentElement;
        }
        // Если не нашли контейнер со скроллом, возвращаем document.documentElement
        return document.documentElement;
    };
    //скрол при клике на кнопку
    function handleClick() {
        if (outScroll && targetRef) {
            targetRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (twinDirection && targetRef && direction === "down" && !outScroll) {
            targetRef.current?.scrollIntoView({
                behavior: "smooth",
                block: twinDirection ? "end" : "start",
            });
            setDirection("up");
        }
        else {
            // Используем найденный контейнер или window
            if (containerRef && scrollContainer) {
                scrollContainer.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }
            else {
                window.scrollBy(0, -window.scrollY);
            }
            location.pathname === "/basket" && setDirection("down");
        }
    }
    //показывать скрывать кнопку при скроле
    const handleScroll = () => {
        if (!twinDirection) {
            if (containerRef && scrollContainer) {
                const scrollTop = scrollContainer.scrollTop;
                setHiddenScroll(scrollTop <= scrollThreshold);
            }
            else {
                if (window.scrollY >= window.innerHeight * multiplierScroll) {
                    setHiddenScroll(false);
                }
                else {
                    setHiddenScroll(true);
                }
            }
        }
    };
    const handleOutScroll = () => {
        if (outScroll && outScroll > 6000) {
            setHiddenScroll(false);
        }
        else {
            setHiddenScroll(true);
        }
    };
    // Инициализация скролл-контейнера
    useEffect(() => {
        if (containerRef?.current) {
            const container = findScrollContainer(containerRef.current);
            setScrollContainer(container);
        }
    }, [containerRef]);
    // Обработка скролла
    useEffect(() => {
        let elementToListen = window;
        if (containerRef && scrollContainer) {
            elementToListen = scrollContainer;
        }
        const scrollHandler = () => {
            if (!outScroll) {
                handleScroll();
            }
            else {
                handleOutScroll();
            }
        };
        if (!outScroll) {
            elementToListen.addEventListener("scroll", scrollHandler);
        }
        else {
            handleOutScroll();
        }
        return () => {
            elementToListen.removeEventListener("scroll", scrollHandler);
        };
    }, [
        outScroll,
        scrollContainer,
        scrollThreshold,
        containerRef,
        twinDirection,
    ]);
    useEffect(() => {
        if (scrollHeight < clientHeight * 1.15) {
            setHiddenScroll(true);
        }
        else if (location.pathname === "/basket" &&
            scrollHeight > clientHeight) {
            setHiddenScroll(false);
            setDirection("down");
        }
    }, [scrollHeight]);
    return (_jsx(Button, { onClick: handleClick, view: "raised", className: b({ hidden: hiddenScroll }), children: direction === "up" ? _jsx(ArrowUp, {}) : _jsx(ArrowDown, {}) }));
};
